import React, { Component } from 'react';
import { Container } from 'reactstrap';

export class ItemGroup extends Component {

  render() {

    let items = this.props.data.map((value,index) => {
      return (
        <this.props.item key={ value.id || value.key || index} itemStyle={ this.props.itemStyle || '' } { ...value } />
      );
    });

    if( items.length === 0 )
      items = <this.props.item itemStyle={ this.props.itemStyle || ''  } empty />;

    return (
      <Container className={"p-0 " + this.props.className} fluid={this.props.full}>
        <this.props.layout { ...this.props.layoutAttributes }>
          { items }
        </this.props.layout>
      </Container>
    );
  }
}

ItemGroup.defaultProps = {
  item: 'SimpleItem'
};



// WEBPACK FOOTER //
// ./src/components/item-group/ItemGroup.js